import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook to dynamically update the HTML lang attribute based on i18n language
 * This ensures the document language matches the app's selected language for:
 * - Screen readers (accessibility)
 * - Search engines (SEO)
 * - Browser features (spell-check, translation tools)
 */
export const useHtmlLang = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (typeof document !== "undefined") {
      const currentLang = i18n.language;
      const htmlElement = document.documentElement;

      // Update the lang attribute
      htmlElement.setAttribute("lang", currentLang);

      console.log(`[HTML Lang] Updated document language to: ${currentLang}`);
    }
  }, [i18n.language]); // Re-run whenever language changes

  return i18n.language;
};
